const siteUrl = 'https://www.beaconsafety.co.nz';

const wooConfig = {
    siteKey: 'BS',
    siteURL: siteUrl,
    ajaxURL: `${siteUrl}/wp-admin/admin-ajax.php`,
    graphURL: `${siteUrl}/graphql`,
    defaultThumbnail: `${siteUrl}/wp-content/uploads/woocommerce-placeholder-190x190.png`,
    consumerKey: 'ck_f9861346b4fd8c55c3f0ac4511f067506bf76e7b',
    consumerSecret: 'cs_821617bdb96f0e226c3aa6eec39e62f8df7d8782',
};

module.exports = wooConfig;